<app-container
	title="Common elements condo details"
	[testHook]="testHooks.CommonElementsCondoDetailsContainer"
>
	<form #form="ngForm" (ngSubmit)="onSubmit(form)">
		<div [@openClose] class="grid grid-cols-2 gap-2">
			<div class="col-span-2">
				<app-input
					name="condoPlan"
					label="Condominium plan"
					[(ngModel)]="propertyType.condoPlan"
					[required]="true"
					[submitted]="form.submitted"
					[testHook]="testHooks.CondominiumPlan"
				></app-input>
			</div>
			<div class="">
				<app-input
					name="percentageInterest"
					label="Percentage interest"
					[startIcon]="ICON.PERCENTAGE"
					type="number"
					[submitted]="form.submitted"
					[(ngModel)]="propertyType.percentageInterest"
					[required]="true"
					lessThanAmount="100"
					[testHook]="testHooks.PercentageInterest"
				></app-input>
			</div>
			<div class="">
				<app-input
					name="commonExpenses"
					label="Common expenses"
					type="cents"
					[startIcon]="ICON.DOLLAR"
					[submitted]="form.submitted"
					[(ngModel)]="propertyType.commonExpenses"
					[required]="true"
					[testHook]="testHooks.CommonExpenses"
				></app-input>
			</div>
		</div>

		<div class="flex justify-between mt-3">
			<div>
				<app-button
					size="small"
					btn="secondary"
					*ngIf="showCancelBtn"
					(click)="onCancelClick()"
					[testHook]="testHooks.CancelButton"
					>Cancel</app-button
				>
			</div>

			<div>
				<app-button size="small" type="submit" [testHook]="testHooks.SaveButton"
					>Save</app-button
				>
			</div>
		</div>
	</form>
</app-container>
